export const validateForHtmlTag = (value: string, overrideErrorMessage?: string): string | undefined => {
	const completeHtmlTagRegex = /<([\w:-]*)\b([^<>]*)\s*>([\s\S]*?)<\/\1>/;
	const selfClosingTagRegex = /<[\w:-]+[\s\w="']*\s?\/>/;

	return new RegExp(`${completeHtmlTagRegex.source}|${selfClosingTagRegex.source}`).test(value)
		? overrideErrorMessage || "Invalid input. HTML tags are not permitted."
		: undefined;
};
